<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main fxFlex class="sm:py-10 sm:px-6" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'your-plan'"></sbnb-helptext-wrapper>
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs></sbnb-page-header>
    </app-feature-flag-tabs>

    <sbnb-loading-spinner *ngIf="loading$ | async"></sbnb-loading-spinner>

    <ng-container *ngIf="subscriptionError$ | async">
      <sbnb-alert-card context="warning" class="flex-col">
        <h3>There was an error loading your plan</h3>
        <p>Please try again later.</p>
      </sbnb-alert-card>
    </ng-container>

    <ng-container *ngIf="(loading$ | async) === false && data$ | async as data">
      <!-- HERO START -->
      <div id="yourplan-hero-container" class="yourplan__hero yourplan__{{ subscriptionColour }}">
        <div fxLayout fxLayoutAlign="space-between center">
          <h2>{{ heroTitle }}</h2>
          <a href="/support-documentation/category/2574375-subscription" target="_blank">
            <sbnb-button size="mini" type="text-secondary">Guide to billing</sbnb-button>
          </a>
        </div>

        <ng-container *ngIf="data.subscription.status === 'trialing'">
          <sbnb-your-plan-hero-item context="neutral">
            The trial period will stop on
            <strong>{{ data.subscription.trial_end | date: 'long' }}</strong>
            ({{ data.subscription.days_left }}
            days left).
          </sbnb-your-plan-hero-item>

          <sbnb-your-plan-hero-item context="neutral">
            Your estimated invoice amount is
            <strong>{{ data.subscription.monthly_rate }}</strong>
            <ng-template [ngTemplateOutlet]="toggleBreakdown"></ng-template>
          </sbnb-your-plan-hero-item>

          <sbnb-your-plan-breakdown
            *ngIf="planBreakdownVisible"
            [subscription]="data.subscription"></sbnb-your-plan-breakdown>

          <sbnb-your-plan-hero-item context="neutral">You need to subscribe to a plan.</sbnb-your-plan-hero-item>
        </ng-container>

        <ng-container *ngIf="data.subscription.status === 'pending'">
          <sbnb-your-plan-hero-item>
            You are subscribed to {{ 'CORE.PRODUCT_NAME' | transloco }} and you are awesome!
          </sbnb-your-plan-hero-item>
          <sbnb-your-plan-hero-item>
            You will be charged on
            <strong>{{ data.subscription.trial_end | date: 'mediumDate' }}</strong>
            , when your trial period ends.
          </sbnb-your-plan-hero-item>
          <sbnb-your-plan-hero-item>
            Your next invoice amount is currently
            <strong>{{ data.subscription.monthly_rate }}</strong>
            <ng-template [ngTemplateOutlet]="toggleBreakdown"></ng-template>
          </sbnb-your-plan-hero-item>

          <sbnb-your-plan-breakdown
            *ngIf="planBreakdownVisible"
            [subscription]="data.subscription"></sbnb-your-plan-breakdown>
        </ng-container>

        <ng-container *ngIf="data.subscription.status === 'active'">
          <sbnb-your-plan-hero-item>
            You are subscribed to {{ 'CORE.PRODUCT_NAME' | transloco }} and you are awesome!
          </sbnb-your-plan-hero-item>
          <sbnb-your-plan-hero-item>
            Your next payment will be on
            <strong>{{ data.subscription.current_period_end | date: 'mediumDate' }}</strong>
            .
          </sbnb-your-plan-hero-item>
          <sbnb-your-plan-hero-item>
            Your next invoice amount is currently
            <strong>{{ data.subscription.monthly_rate }}</strong>
            <ng-template [ngTemplateOutlet]="toggleBreakdown"></ng-template>
          </sbnb-your-plan-hero-item>

          <sbnb-your-plan-breakdown
            *ngIf="planBreakdownVisible"
            [subscription]="data.subscription"></sbnb-your-plan-breakdown>
        </ng-container>

        <ng-container *ngIf="data.subscription.status === 'grace'">
          <sbnb-your-plan-hero-item context="negative">
            The payment due on
            {{ data.subscription.failure_details?.due_date | date: 'mediumDate' }}
            could not be charged on your
            {{ data.subscription.active_payment_method?.brand }} ending in
            {{ data.subscription.active_payment_method?.last4 }}.
          </sbnb-your-plan-hero-item>
          <sbnb-your-plan-hero-item context="negative">
            You need to change your payment method, or contact your bank to clear the transaction.
          </sbnb-your-plan-hero-item>
          <sbnb-your-plan-hero-item>
            Your account will still be valid until
            <strong>{{ data.subscription.grace_period_end | date: 'medium' }}</strong>
            .
          </sbnb-your-plan-hero-item>
        </ng-container>

        <ng-container *ngIf="data.subscription.status === 'paused'">
          <sbnb-your-plan-hero-item>
            Your subscribtion to {{ 'CORE.PRODUCT_NAME' | transloco }} is paused until you resume it.
          </sbnb-your-plan-hero-item>
          <sbnb-your-plan-hero-item>
            Your payment cycle is on pause from
            <strong>{{ data.subscription.current_period_end | date: 'mediumDate' }}.</strong>
          </sbnb-your-plan-hero-item>
          <sbnb-your-plan-hero-item>
            You can resume your subscription to re-activate your account, without any data loss.
          </sbnb-your-plan-hero-item>
        </ng-container>

        <ng-container *ngIf="data.subscription.status === 'ended' || data.subscription.status === 'cancelled'">
          <sbnb-your-plan-hero-item *ngIf="data.subscription.status === 'ended'" context="negative">
            Your trial period has ended
            <ng-container *ngIf="data.subscription.trial_end">
              on
              <strong>{{ data.subscription.trial_end | date: 'mediumDate' }}.</strong>
            </ng-container>
          </sbnb-your-plan-hero-item>
          <sbnb-your-plan-hero-item *ngIf="data.subscription.status === 'cancelled'" context="negative">
            Your subscription has ended
            <ng-container *ngIf="data.subscription.current_period_end">
              on
              <strong>{{ data.subscription.current_period_end | date: 'mediumDate' }}.</strong>
            </ng-container>
          </sbnb-your-plan-hero-item>
          <sbnb-your-plan-hero-item>
            No data was lost: you can reactivate your account at any time by subscribing.
          </sbnb-your-plan-hero-item>

          <sbnb-your-plan-hero-item>
            You need to subscribe to a plan to reactivate your account.
          </sbnb-your-plan-hero-item>
        </ng-container>

        <ng-container *ngIf="data.subscription.status === 'pending_cancellation'">
          <sbnb-your-plan-hero-item context="negative">
            Your subscription will not renew; you will no longer be charged.
          </sbnb-your-plan-hero-item>
          <sbnb-your-plan-hero-item>
            Your subscription will remain active until
            <strong>{{ data.subscription.current_period_end | date: 'mediumDate' }}</strong>
            .
          </sbnb-your-plan-hero-item>
          <sbnb-your-plan-hero-item>
            You can re-activate your subscription at any time, without any data loss.
          </sbnb-your-plan-hero-item>
        </ng-container>
      </div>

      <div class="card__group with-hero mb-9">
        <mat-accordion displayMode="flat">
          <!-- Plans section is exapanded if the user is not active or pending -->
          <mat-expansion-panel
            class="card__group__panel mat-elevation-z0"
            [expanded]="
              (data.subscription?.status !== 'active' &&
                data.subscription?.status !== 'pending' &&
                data.subscription?.status !== 'grace') ||
              (showPlans$ | async)
            ">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="flex gap-4 items-center py-6">
                  <h3 [ngSwitch]="data.subscription.status">
                    <ng-container *ngSwitchCase="'trialing'">Subscribe to a plan to get started</ng-container>
                    <ng-container *ngSwitchCase="'pending_cancellation'">Renew your subscription</ng-container>
                    <ng-container *ngSwitchCase="'paused'">Resume your subscription</ng-container>
                    <ng-container *ngSwitchCase="'active'">Available plans</ng-container>
                    <ng-container *ngSwitchCase="'pending'">Available plans</ng-container>
                    <ng-container *ngSwitchDefault>Change plan</ng-container>
                  </h3>

                  <div *ngIf="data.subscription.plan?.recommended" class="text-night flex items-center gap-1.5">
                    <img
                      class="max-w-4 max-h-4 h-4 w-4"
                      src="/assets/iconography/light-bulb-shine.svg"
                      onload="SVGInject(this)" />
                    <span class="max-w-[420px] text__small">
                      <sbnb-truncate [text]="data.subscription.plan?.recommended"></sbnb-truncate>
                    </span>
                  </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div>
              <div class="flex flex-col gap-8">
                <!-- Change plan -->
                <div class="flex flex-col gap-4">
                  <sbnb-select-plan
                    (renewSubscription)="reactivateSubscription()"
                    (resumeSubscription)="resumeSubscription()"></sbnb-select-plan>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- Addons -->
          <ng-container *ngIf="canManageAddons$ | async">
            <!-- Priority Support -->
            <mat-expansion-panel class="card__group__panel mat-elevation-z0">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="flex gap-4 items-center py-6">
                    <h4 class="night text__large">Upgrade to priority support</h4>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="flex flex-col gap-3 max-w-[750px]">
                <sbnb-priority-support-add-on></sbnb-priority-support-add-on>
              </div>
            </mat-expansion-panel>
            <!-- Smart device add on (Legacy only) -->
            <mat-expansion-panel *ngIf="isActiveLegacy$ | async" class="card__group__panel mat-elevation-z0">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="flex gap-4 items-center py-6">
                    <h4 class="night text__large">Improve your hosting experience with smart devices</h4>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex flex-col gap-3 max-w-[750px]">
                <sbnb-smart-device-add-on></sbnb-smart-device-add-on>
              </div>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>

        <!-- Self serve cancellation with Churnkey -->
        <div class="card__group__card" *ngIf="canCancelSubscription$ | async">
          <sbnb-cancel-subscription-card></sbnb-cancel-subscription-card>
        </div>
      </div>
      <!-- HERO END -->

      <ng-container *ngIf="data.subscription.status !== 'trialing'">
        <h3 class="mb-4">Billing</h3>
        <div class="card__group mb-9">
          <div *ngIf="data.notExpired" class="card__group__card">
            <div class="flex items-center justify-between gap-2">
              <div>
                <div class="flex-1 flex flex-col gap-2">
                  <h4 class="m-0">
                    <a class="link-emphasized" [routerLink]="['/settings/payment-methods']">Payment Methods</a>
                  </h4>
                  <p
                    *ngIf="data.subscription.active_payment_method?.type === 'paypal_express_checkout'"
                    class="nomargin">
                    Your payment method is
                    <strong>Paypal</strong>
                    with email
                    <strong class="nowrap">{{ data.subscription.active_payment_method?.email }}</strong>
                  </p>
                  <p *ngIf="data.subscription.active_payment_method?.type === 'card'" class="nomargin">
                    Your payment method is
                    <strong>{{ data.subscription.active_payment_method?.brand }}</strong>
                    ending in
                    <strong>{{ data.subscription.active_payment_method?.last4 }}.</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="card__group__card" *ngIf="data$ | async as data">
            <div class="flex items-center justify-between gap-2">
              <div class="flex-1 flex flex-col gap-2">
                <h4 class="m-0">
                  <a class="link-emphasized" [routerLink]="['/settings/billing-details']">Billing Details</a>
                </h4>
                <p class="nomargin" *ngIf="!data.notExpired && data.user">
                  Past invoices for
                  <strong>
                    {{ data.user.company ? data.user.company : data.user.first_name + ' ' + data.user.last_name }}
                  </strong>
                  were sent to
                  <strong>{{ data.user.email }}.</strong>
                </p>

                <p *ngIf="data.notExpired && data.user" class="m-0">
                  Invoices for
                  <strong>
                    {{ data.user.company ? data.user.company : data.user.first_name + ' ' + data.user.last_name }}
                  </strong>
                  will be sent to
                  <strong>{{ data.user.email }}.</strong>
                </p>
              </div>
            </div>
          </div>
        </div>

        <h3 class="mb-4">Grow with us</h3>
        <div class="card__group">
          <div class="card__group__card">
            <!-- Investment status from Fairmint -->
            <div
              *ngIf="investmentStatus"
              class="flex items-center justify-between gap-4 flex-wrap"
              id="yourplan-action-invest">
              <div class="flex-1">
                <h4 class="nomargin">
                  <a class="link-emphasized" [href]="investmentStatus.signup_url" target="_blank">
                    Invest into Hospitable, Inc
                  </a>
                </h4>
                <p class="nomargin">
                  {{ investmentStatus.owners }} customers have invested
                  {{ investmentStatus.amount_invested | currency }}
                  into our team and product. Join them!
                </p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>

<ng-template #toggleBreakdown>
  <img
    class="arrow clickable"
    [class.rotate]="planBreakdownVisible"
    src="/assets/iconography/small-arrow-bottom-dark.svg"
    width="24"
    height="24"
    (click)="planBreakdownVisible = !planBreakdownVisible" />
</ng-template>
